import React from 'react';
import { Props_SnippetParagraph } from './Paragraph.props';
import { CompileMarkdown } from '../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler';
import SharedHeading from "../Shared/Heading/Heading";

const SnippetParagraph = (props: Props_SnippetParagraph) => {
    const { heading, repeatable_textProps } = props;
    
    const isHidden = heading.visibility?.value === 'hidden' || (typeof heading.visibility?.value === 'boolean' && heading.visibility?.value === false);
    const alignmentValue = heading.alignment?.value;
    
    // Build class name for snippet-specific alignment classes
    let headingClassName = 'snippet-paragraph__heading';
    if (alignmentValue === 'center') {
        headingClassName += ' snippet-paragraph__heading--center';
    }
    if (isHidden) {
        headingClassName += ' accessible-heading';
    }

    const headingLevel = heading.level?.value as 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' || 'h2';
 
    return (
        <section className="snippet-paragraph">
            <div className="snippet-paragraph__container">

                <SharedHeading
                    className={headingClassName}
                    alignment={
                        alignmentValue === "start" ||
                        alignmentValue === "center" ||
                        alignmentValue === "end"
                            ? alignmentValue
                            : undefined
                    }
                    visibility={!isHidden}
                    level={headingLevel}
                >
                    {heading.text?.value || (heading as any).content?.value}
                </SharedHeading>

                {repeatable_textProps?.map((item, index) => {
                    const { alignment, content } = item;
                    const textAlignmentClass = alignment?.value ? `snippet-paragraph__text--${alignment.value}` : '';
                    return (
                        <div key={index} className={`snippet-paragraph__text ${textAlignmentClass}`}>
                            {content?.value && CompileMarkdown(content.value)}
                        </div>
                    );
                })} 
                </div>
        </section>
    );
};

export default SnippetParagraph;
